module.exports = __webpack_public_path__ + "static/media/info-grey.cdb31d30.svg";